// base
import React, { forwardRef } from 'react';

// libraries
import { Billboard, Text } from '@react-three/drei';

export const TextBoard = forwardRef((props, ref) => {
  const { text } = props;

  return (
    <Billboard ref={ref}>
      <Text font="/assets/fonts/Poppins/Poppins-ExtraBold.ttf" fontSize={34} color="red">
        {text}
      </Text>
    </Billboard>
  );
});
